"use client";
import React, { useState, useEffect } from "react";
import Image from "next/image";
import parse from "html-react-parser";

export const HeroBanner = ({
    image,
    images = [],
    title,
    about = "",
    mobileImage,
    mobileImages = [],
    alt = "Hindustan Power banner",
    mobileAlt = "",
    alts = [],
    mobileAlts = [],
}) => {
    // Normalize: agar array mila hai use karo, warna single image ko array bana do
    const desktopSlides = images.length > 0 ? images : [image].filter(Boolean);
    const mobileSlides =
        mobileImages.length > 0 ? mobileImages : [mobileImage].filter(Boolean);

    const [current, setCurrent] = useState(0);

    useEffect(() => {
        if (desktopSlides.length <= 1) return; // ek hi image hai to slider mat chalao

        const interval = setInterval(() => {
            setCurrent((prev) => (prev + 1) % desktopSlides.length);
        }, 4000); // har 4 second me next image

        return () => clearInterval(interval);
    }, [desktopSlides.length]);

    return (
        <section className="">
            <div className="relative h-[75vh] md:h-[60vh] lg:h-[80vh] xl:h-screen flex flex-col items-center justify-end pb-16 lg:pb-32 overflow-hidden">
                {/* Desktop slides */}
                {desktopSlides.map((img, idx) => (
                    <Image
                        key={`desktop-${idx}`}
                        alt={alts[idx] || alt}
                        src={img}
                        width={50}
                        height={50}
                        unoptimized
                        className={`object-center w-full object-cover absolute top-0 left-0 h-full hidden md:block transition-opacity duration-1000 ease-in-out ${
                            idx === current ? "opacity-100 z-[1]" : "opacity-0 z-0"
                        }`}
                    />
                ))}

                {/* Mobile slides */}
                {mobileSlides.map((img, idx) => (
                    <Image
                        key={`mobile-${idx}`}
                        alt={mobileAlts[idx] || mobileAlt || alt}
                        src={img}
                        width={50}
                        height={50}
                        unoptimized
                        className={`object-center w-full object-cover absolute top-0 left-0 h-full block md:hidden transition-opacity duration-1000 ease-in-out ${
                            idx === current ? "opacity-100 z-[1]" : "opacity-0 z-0"
                        }`}
                    />
                ))}

                <div className="absolute h-full w-full bg-black bg-opacity-50 z-10 top-0 left-0"></div>

                <div className="z-20 relative text-white hp-container w-full md:pr-[20%] xl:pr-[40%]">
                    <h2 className="text-[48px] md:text-[60px] lg:text-[80px] font-normal leading-[58px] md:leading-[70px] lg:leading-[80px] mb-5">
                        {parse(title)}
                    </h2>
                    {about ? (
                        <p className="text-[14px] md:text-[16px] xl:text-[18px] mb-10">
                            {parse(about)}
                        </p>
                    ) : null}
                </div>

                {/* Optional: dots indicator */}
                {desktopSlides.length > 1 && (
                    <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
                        {desktopSlides.map((_, idx) => (
                            <button
                                key={idx}
                                onClick={() => setCurrent(idx)}
                                className={`w-2.5 h-2.5 rounded-full transition-all ${
                                    idx === current ? "bg-white w-6" : "bg-white/50"
                                }`}
                                aria-label={`Slide ${idx + 1}`}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};